export const activatedModules = {
    pim: true,
    dam: true,
    project: true,
    admin: true,
    dashboard: false,
};
